<template>
  <div>
    <v-app-bar flat color="transparent">
      <v-toolbar-title>
        <a @click="$router.go(-1)">Audios</a>
        <v-icon> {{ icons.arrow }} </v-icon>
        <span v-if="form" class="text-capitalize">{{ form.title || 'Untitled' }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <div class="ma-4" v-if="form">
      <v-form ref="form" v-if="form" style="max-width: 400px">
        <v-img
          :src="getImgUrl(form.photo)"
          aspect-ratio="1.7"
          class="mb-5"
        ></v-img>

        <label class="text-field-label pl-4"> Title </label>
        <v-text-field
          flat solo rounded
          required
          background-color="grey lighten-3"
          class="mt-2"
          v-model="form.title"
          :error-messages="form.$getError('title')"
        ></v-text-field>

        <label class="text-field-label pl-4"> Description </label>
        <v-textarea
          flat solo rounded
          required
          background-color="grey lighten-3"
          class="mt-2"
          v-model="form.description"
          :error-messages="form.$getError('description')"
        ></v-textarea>

        <label class="text-field-label pl-4"> Category </label>
        <v-select
          :items="categories"
          item-text="label"
          item-value="id"
          flat solo rounded
          required
          background-color="grey lighten-3"
          class="mt-2"
          label="Please select category"
          v-model="form.category.id"
          :error-messages="form.$getError('description')"
        ></v-select>

        <label class="text-field-label pl-4"> License </label>
        <v-select
          required
          class="mt-2"
          :items="license"
          flat solo rounded
          v-model="form.license"
          label="Please select license"
          background-color="grey lighten-3"
          :error-messages="form.$getError('description')"
        ></v-select>

        <v-btn color="primary" depressed large class="mr-4" @click="updateAudio" :loading="form.$busy" rounded>
          Update
        </v-btn>
      </v-form>
    </div>
    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar.show" right>
      {{ snackbar.message }}
      <v-btn color="pink" text @click="snackbar.show = false">
        Ok
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Audio from '@/models/Audio'
import Category from '@/models/Category'
import { mdiChevronRight } from '@mdi/js'
import Form from '@/utils/form'

export default {
  data () {
    return {
      icons: {
        arrow: mdiChevronRight
      },
      loading: false,
      form: null,
      categories: null,
      snackbar: {
        show: false,
        message: null
      },
      license: [
        { text: 'Standard Play my audio License', value: 'standard' },
        { text: 'Creative Commons - Attribution', value: 'creative_commons' }
      ],
      noImage: require('@/assets/images/no-image.jpeg')
    }
  },

  computed: {
    ...mapState({
      audio: state => state.audio.getAudioDetails
    })
  },

  mounted () {
    this.getAudio()
    this.getCategories()
  },

  methods: {
    async getAudio () {
      Audio.$find(this.$route.params.id)
        .then(group => (this.form = new Form(group)))
    },

    async getCategories () {
      Category.get().then(categories => (this.categories = categories.data))
    },

    updateAudio () {
      this.form.$busy = true
      this.form.$clearErrors()
      this.$api.put(`/audios/${this.form.id}`, {
        title: this.form.title,
        description: this.form.description,
        category_id: this.form.category.id,
        license: this.form.license
      })
        .then(() => {
          this.form.$busy = false
          this.showSnackbar('Audio successfully updated!')
        })
    },

    showSnackbar (message) {
      this.snackbar.message = message
      this.snackbar.show = true
    },

    getImgUrl (image) {
      return image ? image.url : this.noImage
    }
  }
}
</script>
